export const SUPPORTS_ARRAY_PROTOTYPE_LAST_INDEX_OF = "lastIndexOf" in Array.prototype;
